/* eslint-disable react/jsx-pascal-case */
import React, { useState,useRef, useEffect, useContext } from "react";
import axios from "axios";
import { Radio, Table, Input, Form, Modal, Button, ConfigProvider, Col, Row, Switch, message, Tag, Checkbox, Tabs, Space } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import { InboxOutlined, PlusOutlined, EditOutlined, ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import NewTable from "./components/NewTable";
import AdminClassModal from "./components/AdminClassModal";
import Carousel_news_ticker from "./components/Carousel_news_ticker";
import AdminClassSchedulingModal from "./components/AdminClassScheduleModal";
import Label_language from '../language';
import AddTuitionModal from "./components/AddTuitionModal";
import dayjs from 'dayjs';
import './css/TableTitle.css'
const label_language = Label_language.ems.children
const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => !value ? { ...all } : { ...all, [key]: value }, {})
}

const ClassList = () => {
    const [class_week, set_class_week] = useState([]);
    const [class_date, set_class_date] = useState([]);
    const [tuitionModal, setTuitionModal] = useState(false);
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const [total, set_total] = useState(1);
    const [total_schedule, set_total_schedule] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [extra_columns_schedule, set_extra_columns_schedule] = useState(null);
    const [search_date, set_search_date] = useState([])
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [force_reload_schedule, set_force_reload_schedule] = useState(0)
    const [custom_column, set_custom_column] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [scheduleSelectedRowKeys, setScheduleSelectedRowKeys] = useState([]);
    const [choose_column, set_choose_column] = useState([]);
    const [custom_filter_value, set_custom_filter_value] = useState(null);
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [openSchedule, setOpenSchedule] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [messageApi, contextHolder] = message.useMessage();
    const [datas, setDatas] = useState([]);
    const { confirm } = Modal;
    const [msg, setMsg] = useState(0);
    const navigate = useNavigate();
    const [default_column, set_default_column] = useState([
        {
            title: '編號',
            key: 'name_serial',
            dataIndex: 'name_serial',
            align: 'center',
        },
        {
            title: '班級名稱',
            key: 'name',
            dataIndex: 'name',
            align: 'center',
        },
        {
            title: '課程名稱',
            key: 'lesson_name_arr',
            dataIndex: 'lesson_class_data',
            align: 'center',
            render: (text, record, index) => {
                return (
                    <Space direction="vertical">
                        {text.map((value) => {
                            return < >
                                {value?.lesson_name}
                            </>
                        })}
                    </Space>
                )
            },
        },
        {
            title: '環境名稱',
            key: 'surrounding_name',
            dataIndex: 'surrounding_name',
            align: 'center',
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.lesson_time[language],
            key: 'week_time_data',
            dataIndex: 'week_time_data',
            align: 'center',
            disabled: true,
            render: (text, record, index) => {
                return (
                    <Space direction="vertical">
                        {text.map((value) => {
                            return <Tag color="geekblue">
                                星期{value.week_name} {value?.time_start}-{value?.time_end}
                            </Tag>
                        })}
                    </Space>
                )
            },
        },
        {
            title: '授課老師',
            // key: 'name',
            // dataIndex: 'name',
            align: 'center',
            disabled: true,
            render: (text, record, index) => (
                <>
                    {record.teacher_data && record.teacher_data.map((value, i) => {
                        return (
                            <>
                                <p>{value.teacher_name}</p>
                            </>)
                    })}
                </>)
        },
        {
            title: '最高上限人數',
            key: 'upper_limit_people',
            dataIndex: 'upper_limit_people',
            align: 'center',
        },
        {
            title: '招生狀態',
            key: 'enroll_status',
            align: 'center',
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                if (record.enroll_status === true) {
                    return (
                        <>
                            <Switch checked={true} disabled />
                        </>
                    )
                } else {
                    return (
                        <>
                            <Switch checked={false} disabled />
                        </>
                    )
                }
            }
        },
        {
            title: '課程內容',
            key: 'content',
            dataIndex: 'content',
            align: 'center',
        },
        {
            title: '照片',
            sorter: false,
            align: 'center',
            disabled: true,
            render: (text, record, index) => (
                <div
                    style={{
                        padding: 0,
                        margin: 'auto',
                        width: '150px',
                    }}
                >
                    <Carousel_news_ticker
                        file_url={record['file_url']}
                    />
                </div>),
        },
        {
            title: '目前上課人數',
            key: 'student_count',
            dataIndex: 'student_count',
            align: 'center',
        },
        {
            title: '簽到打卡',
            //     key: 'student_count',
            //     dataIndex: 'student_count',
            align: 'center',
            disabled: true,
            sorter: false,
            render: (text, record, index) => (
                record.grade_class_data && record.grade_class_data.map((value) => {
                    return (
                        <>
                            <Button
                                type="primary"
                                onClick={e => window.open(`/cramSchool/QRcodePunch/1/${value.grade_class_id}`)}
                            >前往簽到打卡</Button>
                        </>
                    )
                })
            )
        },
        // {
        //     title: '建立班級繳費項目',
        //     sorter: false,
        //     align: 'center',
        //     disabled: true,
        //     dataIndex: "grade_class_data",
        //     render: (text, record, index) => {
        //         let grade_class_data = record?.grade_class_data ?? []
        //         if (grade_class_data.length > 0) {
        //             return (<Button
        //                 type="primary"
        //                 onClick={() => {
        //                     handleAddTuition(record)
        //                 }}
        //             >建立班級繳費項目
        //             </Button>)
        //         }
        //         else {
        //             return <>-</>
        //         }
        //     }
        // },
        {
            title: '操作',
            align: 'center',
            sorter: false,
            disabled: true,
            render: (text, record, index) => (
                <>
                    <Button type="text"
                        style={{ color: 'rgba(43, 193, 123, 1)' }}
                        onClick={e => {
                            handleOnEditClassRow(record)
                        }} >編輯
                    </Button>
                    <Button danger type="text" onClick={() => showMessage(record.class_id)}>刪除</Button>
                </>
            )

        },
    ]);
    const [default_column_schedule, set_default_column_schedule] = useState([
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.name_serial[language],
            key: 'name_serial',
            dataIndex: 'name_serial',
            align: 'center',
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.class_name[language],
            key: 'name',
            dataIndex: 'name',
            align: 'center',
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.lesson_name[language],
            // key: 'lesson_name',
            // dataIndex: 'lesson_name',
            align: 'center',
            render: (text, record, index) => (
                <>
                    {record.lesson_class_data && record.lesson_class_data.map((value, i) => {
                        return (
                            < >
                                {value.lesson_name}
                            </ >)
                    })}</>
            ),
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.lesson_time[language],
            key: 'week_time_data',
            dataIndex: 'week_time_data',
            align: 'center',
            disabled: true,
            render: (text, record, index) => {
                return (
                    <Space direction="vertical">
                        {text.map((value) => {
                            return <Tag color="geekblue">
                                星期{value.week_name} {value?.time_start}-{value?.time_end}
                            </Tag>
                        })}
                    </Space>
                )
            },
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.admission_time[language],
            // key: 'name',
            // dataIndex: 'name',
            align: 'center',
            render: (text, record, index) => (
                <>{record.admission_class_time_start_default}-{record.admission_class_time_end_default}</>
            ),
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.admission_amount[language],
            key: 'upper_limit_people',
            dataIndex: 'upper_limit_people',
            align: 'center',
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.lesson_date[language],
            // key: 'name',
            // dataIndex: 'name',
            align: 'center',
            render: (text, record, index) => (
                <>{record.class_time_start_default}-{record.class_time_end_default}</>
            ),
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.lesson_teacher[language],
            // key: 'name',
            // dataIndex: 'name',
            width: 150,
            align: 'center',
            render: (text, record, index) => (
                <Space wrap>
                    {record.teacher_data && record.teacher_data.map((value, i) => {
                        return (
                            <Tag color="gold">
                                {value.teacher_name}
                            </Tag>)
                    })}
                </Space>)
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.class_status[language],
            key: 'enroll_status',
            align: 'center',
            disabled: true,
            render: (text, record, index) => {
                return (
                    <>
                        <Button type="primary">確定開班</Button>
                    </>
                )
            }
        },
        {
            title: label_language.Common.children.control[language],
            align: 'center',
            sorter: false,
            render: (text, record, index) => (
                <>
                    <Button
                        type="text"
                        style={{ color: 'rgba(43, 193, 123, 1)' }}
                        onClick={e => handleOnEditRow(record)}>
                        {label_language.Common.children.edit[language]}
                    </Button>
                    <Button
                        type="text"
                        style={{ color: 'red' }}
                        onClick={() => showMessage(record.class_id)}>{label_language.Common.children.delete[language]}
                    </Button>
                </>
            )
        },
    ]);
    const [form] = Form.useForm();
    const [tuitionValues, setTuitionValues] = useState(null)
    const [tabKey, setTabKey] = useState(1)

    const handleOnEditRow = (record) => {
        setTitle(label_language.Common.children.edit[language]);
        setColor('f09a45');
        setEdit(true);
        setOpenSchedule(true);
        setEditCard(record)
        let class_time = []
        if (record?.class_time_start_default && record?.class_time_end_default) {
            class_time = [dayjs(record?.class_time_start_default, 'YYYY-MM-DD'), dayjs(record?.class_time_end_default, "YYYY-MM-DD")]
        }
        let admission_class_time = []
        if (record?.admission_class_time_start_default && record?.admission_class_time_end_default) {
            admission_class_time = [dayjs(record?.admission_class_time_start_default, 'YYYY-MM-DD'), dayjs(record?.admission_class_time_end_default, "YYYY-MM-DD")]
        }
        let teacher_id = record?.teacher_data.map((val) => { return val?.teacher_id })
        let lesson_class_data = record?.lesson_class_data.find((element) => { return true })
        let lesson_id = lesson_class_data?.lesson_id || record?.lesson_id
        form.resetFields()
        form.setFieldsValue({
            ...record,
            class_time: class_time,
            lesson_id: lesson_id,
            teacher_id: teacher_id,
            admission_class_time: admission_class_time,
            // grade_class_id: grade_class_id
        })
    }
    const handleOnEditClassRow = (record) => {
        setTitle('修改班級');
        setColor('f09a45');
        setEdit(true);
        setOpen(true);
        setEditCard(record)
        let grade_class_data = (record?.grade_class_data) ?? []
        let first_grade_class_data = grade_class_data.find(ele => true)
        let grade_class_id = first_grade_class_data?.grade_class_id
        let class_time = []
        if (record?.class_time_start_default && record?.class_time_end_default) {
            class_time = [dayjs(record?.class_time_start_default, 'YYYY-MM-DD'), dayjs(record?.class_time_end_default, "YYYY-MM-DD")]
        }
        let admission_class_time = []
        if (record?.admission_class_time_start_default && record?.admission_class_time_end_default) {
            admission_class_time = [dayjs(record?.admission_class_time_start_default, 'YYYY-MM-DD'), dayjs(record?.admission_class_time_end_default, "YYYY-MM-DD")]
        }
        let teacher_id = record?.teacher_data.map((val) => { return val?.teacher_id })
        let lesson_class_data = (record?.lesson_class_data ?? []).find((element) => { return true })
        let lesson_id = lesson_class_data?.lesson_id ?? record?.lesson_id

        form.resetFields()
        form.setFieldsValue({
            ...record,
            class_time: class_time,
            lesson_id: lesson_id,
            teacher_id: teacher_id,
            grade_class_id,
            admission_class_time,
            enroll_status: record?.enroll_status === true ? true : false
        })

    }
    const handleEdit = (formValues) => {
        if (!formValues?.admission_class_time_start_default || !formValues?.admission_class_time_end_default) {
            formValues = {
                ...formValues,
            }
        }
        let data = {
            ...editcard,
            ...formValues,
        }
        delete data.grade_class_id
        delete data.lesson_id
        if ((data?.grade_class_data.length === 0)) {
            delete data.grade_class_data
        }
        console.log(data)
        axios
            .patch(`/cramSchool/api/class`, [
                {
                    ...data
                }
            ])
            .then((response) => {
                if (response.data.status === 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    reload();
                }
            })
    }
    const showMessage = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    useEffect(() => {
        reload_schedule()
    }, [search_date])
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    const reload_schedule = () => {
        set_force_reload_schedule(prev => prev + 1)

    }
    const handleSubmit = (formValues) => {
        let data = {
            ...editcard,
            ...formValues,
        }
        delete data.grade_class_id
        delete data.lesson_id
        if (!data?.content) {
            data["content"] = ""
        }
        axios
            .post(`/cramSchool/api/class`, [
                {
                    ...data
                }
            ])
            .then((response) => {
                if (response.data.status === 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '新增失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    reload();
                }
            })
    }
    const handleOnDelete = (value) => {
        axios
            .delete(`/cramSchool/api/class`, {
                data: [{ class_id: value }]
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    reload();
                }
            })
    }
    const getData = (param, sort, filter, checklist) => {
        console.log('================= getData 抓取資料 =================')
        let params = {
            cur_page: param?.current,
            size: param?.pageSize,
            custom_filter_key: checklist,
            custom_filter_value: param?.keyword,
            class_time_start_default: search_date[0],
            class_time_end_default: search_date[1],
            order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
        }
        params = setParamsFilter(params)
        axios
            .get('/cramSchool/api/class', {
                params: {
                    ...params,
                    // cur_page: param?.current,
                    // size: param?.pageSize,
                    // custom_filter_key: checklist,
                    // custom_filter_value: param?.keyword,
                    // class_time_start_default: search_date[0],
                    // class_time_end_default: search_date[1],
                    // order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                }
            })
            .then(response => {
                set_total(response.data.total)
                setDatas(response.data.data);
                get_picture(response.data.data);     

            }).catch(error=>console.log(error))
            .finally((error) => {
                set_loading(false)
            })

    }

    
    const abortControllerRef = useRef(null);

    const get_picture = async (data_tmp) => {
        
        // console.log(data_tmp)
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();// 建立取消機制
        console.log('==================== 執行 get_picture ======================')
        const get_file = (file_id, class_id,signal) => {
            console.log('get_file')
            return axios.get('/cramSchool/api/file', { 
                responseType: 'blob', params: { "file_id": file_id }, signal: signal

             })
                .then((response) => {
                    var blob_ = new Blob([response.data], {
                        type: "image/jpg",// this is the only MIME for SVG  

                    });
                    const dataurl = URL.createObjectURL(blob_);
                    setDatas(
                        (pre) => {
                            return (
                                (pre ||[])?.map((value, index) => {
                                    if (class_id == value.class_id) {
                                        if (value.file_url != undefined) {
                                            return (
                                                {
                                                    ...value,
                                                    file_url: [...value.file_url, dataurl]
                                                }
                                            )
                                        } else {
                                            return (
                                                {
                                                    ...value,
                                                    file_url: [dataurl]
                                                }
                                            )
                                        }
                                    } else {
                                        return (
                                            { ...value }
                                        )

                                    }
                                })
                            )
                        }
                    )
                    console.log('suceess')
                    return 'suceess'
                }).catch(error => {
                    if (axios.isCancel(error)) {
                        console.log('Request canceled', error.message);
                    }
                    console.log('error')
                    return 'error'
                })
        }

        // 執行 get_picture
        // ======================= 資料處理 ===============================
        let getFiledata = []
        data_tmp && data_tmp.map((value, index) => {
            let class_id = value['class_id']
            if (value.file_id.length !== 0) {
                value.file_id.map((tmp, key) => {
                    getFiledata.push({ 'tmp': tmp, 'class_id': class_id })
                })
            }
        })
        let size = 10//資料每幾 size 切割成一包 
        // 
        for (let i = 0; i < getFiledata.length; i += size) {
            const chunk = getFiledata.slice(i, i + size);
            // console.log('寄送的chunk',chunk)
            try {
                // 使用 Promise.all 處理非同步問題
                const responses = await Promise.all(chunk.map(file => 
                    get_file(file.tmp, file.class_id,abortControllerRef.current.signal)));
                console.log('處理完成:',responses);
            } catch (error) {
                console.error('處理失敗', error);   
            }

        }
        console.log('======================= 結束 ===============================')

    }
    
    const getDatas = (param, sort, filter, checklist) => {
        // console.log(param);
        set_loading(true);
        set_choose_column(checklist);
        set_custom_filter_value(param?.keyword);
        let params = {
            cur_page: param?.current,
            size: param?.pageSize,
            custom_filter_key: checklist,
            custom_filter_value: param?.keyword,
            // employment_time_start: search_date[0],
            // employment_time_end: search_date[1],  
            order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
        }
        params = setParamsFilter(params)
        return axios
            .get('/cramSchool/api/admission_class', {
                params: {
                    ...params
                },
                // paramsSerializer: function (params) {
                //     const NewParams = Object.entries(params).map(([map_key, map_value]) => {
                //         if (map_key === 'order') {
                //             return Object.entries(map_value).map(([map_value_key,map_value_value], i) => {
                //                 return `order[${i}][column]=${map_value_key}&order[${i}][type]=${map_value_value}`;
                //             })
                //         }else if (map_key === 'custom_filter_key') {
                //             return map_value.map(map_item=>`custom_filter_key[]=${map_item}`).join("&");
                //         }else{
                //             return `${map_key}=${map_value}`;
                //         }
                //     })
                //     return NewParams.join("&")
                // },
            })
            .then((response) => {
                set_total_schedule(response.data.total)
                setDatas(response.data.data);
            })
            .finally(() => {
                set_loading(false)
            })
    }
    useEffect(() => {
        // getData() 
        // getDatas()
    },[])
    const handleOnAddRow = () => {
        setTitle('新增班級');
        setColor('d65b77');
        setEdit(false);
        setOpen(true);
        setEditCard({});
        form.resetFields()
    }

    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value, i) => {
                deleterow.push({ 'class_id': value })
            })
            axios
                .delete(`/cramSchool/api/class`, {
                    data: deleterow
                })
                .then((response) => {
                    if (response.data.status == 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload()
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload()
                    }
                })
        }
    }
    const handleSearchDate = (date) => {
        set_search_date(date);
    }
    const handleOnAddScheduleRow = () => {
        setTitle(label_language.Common.children.add[language]);
        setColor('d65b77');
        setEdit(false);
        setOpenSchedule(true);
        setEditCard({});
        set_class_date([]);
        set_class_week([]);
        form.resetFields()
    }
    const handleEditSchedule = (formValues) => {
        let data = {
            ...editcard,
            ...formValues,
        }
        delete data.grade_class_id
        delete data.lesson_id

        axios
            .patch(`/cramSchool/api/admission_class`, [
                {
                    ...data
                }
            ])
            .then((response) => {
                if (response.data.status === 'failure') {
                    setOpenSchedule(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                    reload_schedule();
                } else {
                    setOpenSchedule(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                    reload_schedule();
                }
            })
        // }
    }
    const handleSubmitSchedule = (formValues) => {
        let data = {
            ...editcard,
            ...formValues,
        }
        delete data.grade_class_id
        axios
            .post(`/cramSchool/api/admission_class`, [
                {
                    ...data,
                    content: ""
                }
            ])
            .then((response) => {
                if (response.data.status === 'failure') {
                    setOpenSchedule(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.add_error[language],
                    });
                } else {
                    setOpenSchedule(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.add_success[language],
                    });
                    reload();
                }
            })
    }
    const handleOnDeleteScheduleRow = () => {
        if (scheduleSelectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            scheduleSelectedRowKeys && scheduleSelectedRowKeys.map((value, i) => {
                deleterow.push({ 'class_id': value })
            })
            axios
                .delete(`/cramSchool/api/admission_class`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status != 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.delete_error[language],
                        });
                        reload_schedule();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.delete_success[language],
                        });
                        reload_schedule();
                    }
                })
        }
    }
    const handleAddTuition = (record) => {
        setColor('d65b77');
        setEdit(false);
        setEditCard({});
        set_class_date([]);
        set_class_week([]);
        setTuitionModal(true);
        form.resetFields()
        let grade_class_data = record?.grade_class_data ?? []
        let grade_class_first_data = grade_class_data.find((element) => { return true })
        let grade_class_id = grade_class_first_data?.grade_class_id
        let lesson_class_data = record?.lesson_class_data ?? []
        let lesson_class_data_first = lesson_class_data.find(ele => true)
        setTuitionValues({
            ...record,
            ...lesson_class_data_first,
            grade_class_id: grade_class_id
        })
    }
    const getTabs = (key) => {

        setTabKey(key)
        // if (key === 1) {
        //     getData();
        // } else {
        //     getDatas();
        // }
    }
    return (
        <>
            {contextHolder}
            <AdminClassModal
                force_reload={force_reload}
                propsForm={form}
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setOpen={setOpen}
                setEditCard={setEditCard}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
            />
            <AdminClassSchedulingModal
                open={openSchedule}
                edit={edit}
                title={title}
                color={color}
                propsForm={form}
                editcard={editcard}
                setEditCard={setEditCard}
                set_class_date={set_class_date}
                class_week={class_week}
                set_class_week={set_class_week}
                class_date={class_date}
                setOpen={setOpenSchedule}
                handleEdit={handleEditSchedule}
                handleSubmit={handleSubmitSchedule}
            />
            <AddTuitionModal
                defaultValue={tuitionValues}
                open={tuitionModal}
                setOpen={setTuitionModal}
                editcard={editcard}
                setEditCard={setEditCard}
                set_class_date={set_class_date}
                class_week={class_week}
                set_class_week={set_class_week}
                class_date={class_date}
                color={color}
            />

            <Row gutter={[8, 16]} style={{ paddingTop: '10px' }}>
                <Col span={24}>
                    <Tabs
                        type="card"
                        onChange={key => getTabs(key)}
                        items={[
                            {
                                label: '已開班',
                                key: 1,
                                // children: (<>
                                //     <NewTable
                                //         total={total}
                                //         extra_columns={extra_columns}
                                //         set_extra_columns={set_extra_columns}
                                //         loading={loading}
                                //         page_name={'ClassList'}
                                //         force_reload={force_reload}
                                //         columns={default_column.concat(extra_columns || [])}
                                //         getData={getData}
                                //         datas={datas}
                                //         add_button_title={'新增班級'}//新增按鈕上的名稱
                                //         handleOnAddRow={handleOnAddRow}//新增row 內容
                                //         rowkey={'class_id'}//key
                                //         setSelectedRowKeys={setSelectedRowKeys}
                                //         selectedRowKeys={selectedRowKeys}
                                //         handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                                //     ></NewTable>
                                // </>)
                            }, {
                                label: '招生中',
                                key: 2,
                                // children: (<>
                                //     <NewTable
                                //         total={total_schedule}
                                //         extra_columns={extra_columns_schedule}
                                //         set_extra_columns={set_extra_columns_schedule}
                                //         loading={loading}
                                //         page_name={'ClassScheduleList'}
                                //         force_reload={force_reload_schedule}
                                //         columns={default_column_schedule.concat(extra_columns_schedule || [])}
                                //         getData={getDatas}
                                //         datas={datas}//table資料
                                //         add_button_title={label_language.course_arrangement_management.children.AdminClassScheduling.children.add_lesson_schedule[language]}//新增按鈕上的名稱
                                //         handleOnAddRow={handleOnAddScheduleRow}//新增row 內容
                                //         rowkey={'class_id'}//key
                                //         setSelectedRowKeys={setScheduleSelectedRowKeys}
                                //         selectedRowKeys={scheduleSelectedRowKeys}
                                //         handleOnDeleteRow={handleOnDeleteScheduleRow}//多筆刪除
                                //         searchdate={true}
                                //         rangepicker_title={'授課時間'}
                                //         handleSearchDate={handleSearchDate}//搜尋日期
                                //     ></NewTable>
                                // </>)
                            }
                        ]}
                    />
                </Col>
                <Col span={24}>
                    {
                        tabKey === 1 &&
                        <NewTable
                            total={total}
                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            loading={loading}
                            page_name={'ClassList'}
                            force_reload={force_reload}
                            columns={default_column.concat(extra_columns || [])}
                            getData={getData}
                            datas={datas}
                            add_button_title={'新增班級'}//新增按鈕上的名稱
                            handleOnAddRow={handleOnAddRow}//新增row 內容
                            rowkey={'class_id'}//key
                            setSelectedRowKeys={setSelectedRowKeys}
                            selectedRowKeys={selectedRowKeys}
                            handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                            QRcodePunch={true}
                            handleQRcodePunch ={()=>{
                                window.open(`/cramSchool/QRcodePunch/1`)
                            }}
                        ></NewTable>
                    }
                    {
                        tabKey === 2 &&
                        (<NewTable
                            total={total_schedule}
                            extra_columns={extra_columns_schedule}
                            set_extra_columns={set_extra_columns_schedule}
                            loading={loading}
                            page_name={'ClassScheduleList'}
                            force_reload={force_reload_schedule}
                            columns={default_column_schedule.concat(extra_columns_schedule || [])}
                            getData={getDatas}
                            datas={datas}//table資料
                            add_button_title={label_language.course_arrangement_management.children.AdminClassScheduling.children.add_lesson_schedule[language]}//新增按鈕上的名稱
                            handleOnAddRow={handleOnAddScheduleRow}//新增row 內容
                            rowkey={'class_id'}//key
                            setSelectedRowKeys={setScheduleSelectedRowKeys}
                            selectedRowKeys={scheduleSelectedRowKeys}
                            handleOnDeleteRow={handleOnDeleteScheduleRow}//多筆刪除
                            searchdate={true}
                            rangepicker_title={'授課時間'}
                            handleSearchDate={handleSearchDate}//搜尋日期
                        ></NewTable>)
                    }
                </Col>
            </Row>
        </>

    );
};
export default ClassList;